export default __webpack_public_path__ + "static/logo_dieteren~yKrPVKbB-58d1994625e4f47ec4a4404ab0e3d18f.png";